




import { defineComponent, ref, onMounted } from '@vue/composition-api';
import ViewContainer from '../components/ViewContainer.vue';
import { messenger } from '../messenger';
import { TapGesture, PanGesture, GestureState, Direction } from '../prototyping/pointer-input';

type EventType = 'none' | 'tap' | 'pan';

const dummyBaseEvent = (ev: PointerEvent) => ({
  id: ev.pointerId,
  pointerType: ev.pointerType as 'touch' | 'pen' | 'mouse',
  pointerCount: 1,
  timestamp: Date.now(),
  relativeCenter: { x: ev.offsetX * window.devicePixelRatio, y: ev.offsetY * window.devicePixelRatio },
  viewportCenter: { x: ev.clientX * window.devicePixelRatio, y: ev.clientY * window.devicePixelRatio },
});

const dummyTapEvent = () => ({
  tapCount: 1,
});

const dummyPanEvent = () => ({
  panDelta: { x: 0, y: 0, total: 0 },
  panVelocity: { x: 0, y: 0, total: 0 },
  panDirection: Direction.NONE,
});

export default defineComponent({
  name: 'ARTest',
  components: {
    ViewContainer,
  },
  setup() {
    const rootRef = ref<HTMLElement | null>(null);
    const input = messenger.unity?.input;

    let currentEvent: EventType = 'none';

    onMounted(() => {
      if (rootRef.value) {
        rootRef.value.addEventListener('pointerdown', () => {
          currentEvent = 'tap';
        });

        rootRef.value.addEventListener('pointermove', (ev) => {
          if ((currentEvent === 'tap' && Math.abs(ev.movementX) > 20) || Math.abs(ev.movementY) > 20) {
            currentEvent = 'pan';

            const payload: PanGesture = {
              state: GestureState.BEGIN,
              ...dummyBaseEvent(ev),
              ...dummyPanEvent(),
              name: 'pan',
            };

            if (input) input.sendPan(payload);
          } else if (currentEvent === 'pan') {
            const payload: PanGesture = {
              state: GestureState.PROGRESS,
              ...dummyBaseEvent(ev),
              ...dummyPanEvent(),
              name: 'pan',
            };

            if (input) input.sendPan(payload);
          }
        });

        rootRef.value.addEventListener('pointerup', (ev) => {
          if (currentEvent === 'tap') {
            const payload: TapGesture = {
              ...dummyBaseEvent(ev),
              ...dummyTapEvent(),
              name: 'tap',
            };

            if (input) input.sendTap(payload);
          } else if (currentEvent === 'pan') {
            const payload: PanGesture = {
              state: GestureState.END,
              ...dummyBaseEvent(ev),
              ...dummyPanEvent(),
              name: 'tap',
            };

            if (input) input.sendPan(payload);
          }

          currentEvent = 'none';
        });

        rootRef.value.addEventListener('pointercancel', (ev) => {
          ev.preventDefault();
        });
      }
    });

    return {
      rootRef,
    };
  },
});
